import React from 'react';
import * as Yup from 'yup';
import MasterManager from '../../components/expense/MasterManager';
import useExpenseLookups, { withCurrent } from '../../components/expense/useExpenseLookups';
import { userLabel } from '../../services/expenseMastersApi';

const schema = Yup.object().shape({
  name: Yup.string().trim().required('Name is required').max(100),
});

// Owner: Accounts
const JobNameMaster = ({ canEdit }) => {
  const { users } = useExpenseLookups(canEdit ? ['users'] : []);

  return (
    <MasterManager
      resource="jobNames"
      title="Job Name"
      canEdit={canEdit}
      columns={[
        { key: 'name', label: 'Job Name' },
        { key: 'owner', label: 'Owner', render: (r) => userLabel(r.ownerUserId) },
      ]}
      fields={(editing) => [
        { name: 'name', label: 'Job Name', required: true },
        {
          name: 'ownerUserId', label: 'Owner', type: 'autocomplete',
          options: withCurrent(users, editing?.ownerUserId?._id, userLabel(editing?.ownerUserId)),
        },
      ]}
      validationSchema={schema}
      emptyValues={{ name: '', ownerUserId: '' }}
      toForm={(r) => ({ name: r.name || '', ownerUserId: r.ownerUserId?._id || '' })}
      toPayload={(v) => ({ name: v.name, ownerUserId: v.ownerUserId })}
    />
  );
};

export default JobNameMaster;
